<div class="row__wrapper">
  <ng-content></ng-content>
</div>
